import { useQuery } from '@tanstack/react-query';
import { exchangeRateQueryOptions } from '../server/queries/exchange-rate';

/**
 * Fetches the current GCS/ICS exchange rate.
 */
export function useExchangeRate() {
  return useQuery(exchangeRateQueryOptions());
}
